import React from 'react'
import { TotalRewardPoints as styles } from './chat.tailwind'
import { useSelector } from 'react-redux';
import { Divider } from '@mui/material';

const TotalRewardPoints = () => {
  const { userPointsAndRewards } = useSelector((state) => state.reward);

  return (
    <div className={styles.container}>
        <div className={styles.points_container}>
            <h1 className={styles.rewardPoints}>{userPointsAndRewards?.userTotalEarnedPoints}</h1>
            <p className={styles.rewardPointHeading}>LIFETIME POINTS</p>
        </div>

        <Divider className='bg-[#A98743] h-[1px] w-[40%]' />

        <div className={styles.points_container}>
            <h1 className={styles.rewardPoints}>{userPointsAndRewards?.userTotalAvailablePoints}</h1>
            <p className={styles.rewardPointHeading}>AVAILABLE POINTS</p>
        </div>
    </div>
  )
}

export default TotalRewardPoints